import React,{useState} from 'react';
import { Modal } from 'antd';
import Logo from '../../components/Logo/Logo';
import ProgressBar from './ProgressBar/ProgressBar';
import stylesSideBar from './SideBar.module.scss';
import { useSelector } from 'react-redux';
import DatiSideBar from './DatiSideBar/DatiSideBar';
import RiepilogoPreventivo from '../../components/PreventivoSideBar/PreventivoSideBar';

import Immagine from '../../components/Immagine/Immagine';


const SideBar = (props) => {

    const steps = useSelector(state => state.dataReducer.modello.currentStep);
    const preventivo = useSelector(state => state.dataReducer.modello.datiPratica);
    const linkHome = useSelector(state => state.dataReducer.documentiPdf.linkHome);
    const [visibleModal,setVisibleModal] = useState(false);
    const importoSeparatore = applicaSeparatore(convertNumberFloat(preventivo.importo));
    let progressBarIntestatario = 'non_completato';
    let progressBarAnagrafici = 'non_completato';
    let progressBarLavoro = 'non_completato';
    let progressBarRiepilogo = 'non_completato';

    function showModal(){
            setVisibleModal(!visibleModal);
    }

    function convertNumberFloat(number){
        return ((number).toFixed(2)).replace('.',',');
    }

    function applicaSeparatore(importoNumerico){  
        var importo = importoNumerico.toString();  
        if(importo.length>3){  
          importo = importo.split('',importo.length).reverse().join('').replace(/([0-9]{3})/g,'$1.');  
          importo = importo.split('',importo.length).reverse().join('');  
        }  
        return importo;  
      }  


    if(steps === 1 || steps === 2 || steps === 3 || steps === 4){
        progressBarIntestatario = 'progress';
        progressBarAnagrafici = 'non_completato';
        progressBarLavoro = 'non_completato';
        progressBarRiepilogo = 'non_completato';
    }else if(steps === 5 || steps === 6 || steps === 7 || steps === 8){
        progressBarIntestatario = 'completato';
        progressBarAnagrafici = 'progress';
        progressBarLavoro = 'non_completato';
        progressBarRiepilogo = 'non_completato';
    }else if(steps === 9 || steps === 10){
        progressBarIntestatario = 'completato';
        progressBarAnagrafici = 'completato';
        progressBarLavoro = 'progress';
        progressBarRiepilogo = 'non_completato';
    }else if(steps === 11 || steps === 12){
        progressBarIntestatario = 'completato';
        progressBarAnagrafici = 'completato';
        progressBarLavoro = 'completato';
        progressBarRiepilogo = 'completato';
    }

    return(
    <div className={stylesSideBar.SideBar}>

        {
            steps <= 12 ? (
                <>
                    <div className={stylesSideBar.SideBarDesktop}>
                        <a href={linkHome}><Logo /></a>
                        {
                            steps === 12 ? (
                                <button className={`${stylesSideBar.buttonPrestito} ${stylesSideBar.buttonPrestitoDisabled}`} >Il tuo prestito PrestiPay</button>
                            ): (
                                <button className={stylesSideBar.buttonPrestito} onClick={showModal}>Il tuo prestito PrestiPay <Immagine urlImage={'white.svg'} name='Il tuo prestito PrestiPay' /></button>
                            )
                        }
                        

                        <ProgressBar titolo="Dati Intestatario" sottoCampi="Dati Personali,Contatti,Dati Bancari,Esposizione Politica" situazione={progressBarIntestatario} />
                        <ProgressBar titolo="Dati Anagrafici" sottoCampi="Cittadinanza,Stato Civile,Residenza,Documento di riconoscimento" situazione={progressBarAnagrafici}  />
                        <ProgressBar titolo="Situazione Lavorativa" sottoCampi="Dati Lavorativi,Reddito" situazione={progressBarLavoro} />
                        <ProgressBar titolo="Riepilogo" sottoCampi="" situazione={progressBarRiepilogo}  />


                        <DatiSideBar />
                    </div>

                    <div className={stylesSideBar.SideBarMobile}>
                        <a href={linkHome} target="_blank" rel="noopener noreferrer"><Logo /></a>
                        { 
                            steps < 12 ? (
                                <Immagine  class={stylesSideBar.buttonPrestitoMobile} clicked={showModal} urlImage={'white.svg'} name='menu' />
                            ) : null
                        }

                        <div className={(steps === 11 || steps === 12) ? `${stylesSideBar.ContentProgressBar} ${stylesSideBar.ContentProgressBarLastStep}` : `${stylesSideBar.ContentProgressBar}` }>
                            <ProgressBar titolo="Dati Intestatario" sottoCampi="Dati Personali,Contatti,Dati Bancari,Esposizione Politica" situazione={progressBarIntestatario} />
                            <ProgressBar titolo="Dati Anagrafici" sottoCampi="Cittadinanza,Stato Civile,Residenza,Documento di riconoscimento" situazione={progressBarAnagrafici}  />
                            <ProgressBar titolo="Situazione Lavorativa" sottoCampi="Dati Lavorativi,Reddito" situazione={progressBarLavoro} />
                            <ProgressBar titolo="Riepilogo" sottoCampi="" situazione={progressBarRiepilogo}  />
                        </div>


                    </div>
                </>
            
            ) : (

                <>
                    <div className={stylesSideBar.SideBarDesktop}>
                        <a href={linkHome} target="_blank" rel="noopener noreferrer"><Logo /></a>
                        <button className={`${stylesSideBar.buttonPrestitoUploadDocs}`}>Il tuo prestito PrestiPay</button>

                        <div className={stylesSideBar.singoloDatoPreventivo}>
                            <h2 className={stylesSideBar.titoloDatoPreventivo}>Importo</h2>
                            <p className={stylesSideBar.valoreDatoPreventivo}>{importoSeparatore}€</p>
                        </div>

                        <div className={stylesSideBar.singoloDatoPreventivo}>
                            <h2 className={stylesSideBar.titoloDatoPreventivo}>Durata</h2>
                            <p className={stylesSideBar.valoreDatoPreventivo}>{preventivo.numeroRate} mesi</p>
                        </div>

                        <div className={stylesSideBar.singoloDatoPreventivo}>
                            <h2 className={stylesSideBar.titoloDatoPreventivo}>Assicurazione</h2>
                            <p className={stylesSideBar.valoreDatoPreventivo}>{preventivo.assicurazione ? 'SI' : 'NO'}</p>
                        </div>

                        <div className={stylesSideBar.singoloDatoPreventivo}>
                            <h2 className={stylesSideBar.titoloDatoPreventivo}>TAEG</h2>
                            <p className={stylesSideBar.valoreDatoPreventivo}>{convertNumberFloat(preventivo.taeg)}%</p>
                        </div>

                        <div className={stylesSideBar.singoloDatoPreventivo}>
                            <h2 className={stylesSideBar.titoloDatoPreventivo}>TAN</h2>
                            <p className={stylesSideBar.valoreDatoPreventivo}>{convertNumberFloat(preventivo.tan)}%</p>
                        </div>

                        <div className={`${stylesSideBar.singoloDatoPreventivo} ${stylesSideBar.Yellow}`}>
                            <h2 className={stylesSideBar.titoloDatoPreventivo}>RATA</h2>
                            <p className={stylesSideBar.valoreDatoPreventivo}>{convertNumberFloat(preventivo.rata)}€/mese</p>
                        </div>

                    </div>

                    <div className={stylesSideBar.SideBarMobile}>
                        <a href={linkHome} target="_blank" rel="noopener noreferrer"><Logo /></a>
                    </div>
                </>
            )
        
        }
        

        <Modal onCancel={showModal} open={visibleModal} className={stylesSideBar.ModalPreventivo} closeIcon={<Immagine urlImage={'close-modal.svg'} name='close' />} >
            <RiepilogoPreventivo />
        </Modal>
    </div>
    )
}

export default SideBar;